import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useIsMount from 'helpers/useIsMount'

import FetchMore from 'js/components/FetchMore'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import SearchBar from 'js/components/SearchBar/SearchBar'

import Attendee from './Attendee'
import { GET_ATTENDEES_LIST } from './AttendeesList.queries'

const AttendeesList = ({ guid, state }) => {
    const PAGE_SIZE = 50

    const [searchInput, setSearchInput] = useState('')

    const onChangeSearchInput = (evt) => {
        setSearchInput(evt.target.value)
    }

    const [q, setQ] = useState('')
    const onSubmitSearchInput = (evt) => {
        evt.preventDefault()
        setQ(searchInput)
    }

    const { loading, data, fetchMore, refetch } = useQuery(GET_ATTENDEES_LIST, {
        variables: {
            query: q,
            guid,
            state,
            offset: 0,
            limit: PAGE_SIZE,
        },
    })
    const isMount = useIsMount()

    useEffect(() => {
        if (isMount) {
            refetch()
        }
    })

    const { t } = useTranslation()

    return (
        <>
            <form method="GET" onSubmit={onSubmitSearchInput}>
                <SearchBar
                    name="search-attendee"
                    value={searchInput}
                    onChange={onChangeSearchInput}
                    label={t('entity-event.search-attendee')}
                    borderStyle="rounded"
                    style={{ margin: '20px 0 8px' }}
                />
            </form>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <FetchMore
                    edges={data.entity.attendees.edges}
                    getMoreResults={(data) => data.entity.attendees.edges}
                    fetchMore={fetchMore}
                    fetchCount={50}
                    maxLimit={data.entity.attendees.total}
                    isScrollableBox
                >
                    <div style={{ padding: '8px 0' }}>
                        {data.entity.attendees.edges.map((attendee) => (
                            <Attendee
                                key={`attendee-${
                                    attendee.guid || attendee.email
                                }`}
                                entity={attendee}
                                containerGuid={data.entity.guid}
                                containerCanEdit={data.entity.canEdit}
                            />
                        ))}
                    </div>
                </FetchMore>
            )}
        </>
    )
}

export default AttendeesList
